import { Component } from "react";
import PropTypes from "prop-types";
import ListingItem from "../LisingItem";
import List from "@material-ui/core/List";

export default class LsysLoans extends Component {
  render() {
    let application = this.props.application;
    let caution = application.LsysLoanGuid || application.LsysLoanTerminated;
    let good = !caution && application.LsysLoanCount;

    return (
      <div>
        <List>
          {good ? (
            <ListingItem
              primaryText={"Good"}
              primaryTextStyle={{ color: "green" }}
            />
          ) : undefined}
          {caution ? (
            <ListingItem
              primaryText={"Caution!"}
              primaryTextStyle={{ color: "red" }}
            />
          ) : undefined}
          <ListingItem
            secondaryText={"Lsys Loan count: " + application.LsysLoanCount}
          />
          <ListingItem
            secondaryText={
              "Lsys terminated loan count: " + application.LsysLoanTerminated
            }
          />
          {application.LsysLoanGuid ? (
            <ListingItem secondaryText={"Active loan in Lsys with id:"} />
          ) : undefined}
          {application.LsysLoanGuid ? (
            <ListingItem secondaryText={application.LsysLoanGuid} />
          ) : undefined}
        </List>
      </div>
    );
  }

  static propTypes = {
    application: PropTypes.object,
  };
}
